import React from "react";

import {
    FaDownload,
    FaCopy,
    FaKey,
    FaGlobe,
    FaCheckCircle
} from "react-icons/fa";

//import {handleDownloadEA}  from "./Dashboard";


class ExpertAdvisorCard extends React.Component {


    constructor(props){

        super(props);


        this.state = {

            copied:false

        };


    }





    copyActivationCode = () => {


        const code =
            this.props.activationCode ||
            "ACT-8F7A93D2";


        navigator.clipboard.writeText(code);



        this.setState({

            copied:true

        });



        setTimeout(()=>{


            this.setState({

                copied:false

            });


        },2000);



    }





    downloadEA = () => {


        /*
        
        Later:

        Call your Lambda endpoint:

        GET /download-bot

        Authorization:
        Cognito Token


        */


        console.log(
            "Download MT5 EA"
        );


    }





    render(){


        const activationCode =
              this.props.activationCode ||
              "Download EA to generate activation code"


        return (



            <div className="idms-card expert-advisor-card">



                <div className="card-header">


                    <div>


                        <h2 className="card-title">

                            MT5 Expert Advisor

                        </h2>


                        <p className="card-subtitle">

                            Download and connect your iDMS trading assistant

                        </p>


                    </div>



                    <FaKey

                        className="header-icon"

                    />


                </div>






                <div className="ea-row">


                    <span className="ea-label">

                        Version

                    </span>


                    <span className="ea-value">

                        1.0.3

                    </span>


                </div>





                <div className="ea-row">


                    <span className="ea-label">

                        Platform

                    </span>


                    <span className="ea-value">

                        MetaTrader 5

                    </span>


                </div>





                <div className="activation-box">


                    <div>


                        <span>

                            Activation Code

                        </span>


                        <strong>

                            {activationCode}

                        </strong>


                    </div>




                    <button

                        className="idms-btn idms-btn-secondary"

                        onClick={
                            this.copyActivationCode
                        }


                    >


                        {

                        this.state.copied

                        ?

                        <>

                        <FaCheckCircle />

                        Copied

                        </>


                        :

                        <>

                        <FaCopy />

                        Copy

                        </>


                        }



                    </button>


                </div>







                <button


                    className="idms-btn idms-btn-primary download-button"


                    onClick={
                        this.props.onDownloadEA
                    }


                >


                    <FaDownload />


                    &nbsp;


                    Download MT5 EA



                </button>







                <div className="instruction-box">



                    <h4>


                        Installation Instructions


                    </h4>





                    <p>


                        1. Download the iDMS Expert Advisor.


                    </p>



                    <p>


                        2. Open MetaTrader 5.


                    </p>


                     <p>


                        3. Install the EA into :


                    </p>


                    <p>

                            &nbsp; &nbsp;  MT5 → Open Data Folder → MQL5 → Experts  → Advisors 
                            

                    </p>




                    <p>


                        4. Attach the EA to your preferred chart.


                    </p>




                    <p>


                        5. Enter your activation code.


                    </p>




                </div>








                <div className="webrequest-box">



                    <FaGlobe />


                    <div>


                        <strong>

                            Required MT5 Permission

                        </strong>



                        <p>

                            Add the following URL:

                        </p>



                        <code>

                            https://idms-invest.com

                        </code>




                        <p>

                            MT5 → Tools → Options →
                            Expert Advisors →
                            Allow WebRequest

                        </p>



                    </div>


                </div>





            </div>


        );


    }


}



export default ExpertAdvisorCard;